<template>
  <div class="sale-rep-index">
    <div class="group-info">
      <div class="group-logo">
        <img src="@/assets/images/stjt.png" alt="">
      </div>
      <div class="group-name">StoneGroup</div>
    </div>

    <div class="rep-form">
      <van-form>
        <div class="service-sn">
          <van-field
            class="service-sn-field"
            v-model="formData['sn_num']"
            name="服务器SN号"
            label=""
            placeholder="请输入服务器SN号"
            right-icon="scan"
            @click-right-icon="scanShow = true;"
          >
          </van-field>
        </div>
        
        <div v-if="$route.meta.params && $route.meta.params.type == 'repair'" class="form-submit-button">
          <div class="form-submit-box">
            <van-button round block type="primary" @click="turnTo('list')" class="search-btn list-btn">
              工单列表
            </van-button>

            <van-button round block type="primary" @click="turnTo('reqpair')" class="search-btn">
              在线报修
            </van-button>
          </div>
          
        </div>
        <p
          v-else
          class="st-opt-btn search-btn"
          style="background-color: rgb(42 130 228);border-radius: 5px;"
          @click="search"
        >
          查&nbsp;&nbsp;询
        </p>
      </van-form>
    </div>
    
    <div style="width: 100%; position: fixed;bottom: 19px;color: rgba(128, 128, 128, 1);font-size: 12px;line-height: 150%;text-align: center;">© StoneGroup All Rights Reserved.</div>
    <scan :visable.sync="scanShow" v-if="scanShow" @detect="scanDetect"></scan>
    <loading v-if="pagePushLoading"/>
  </div>
</template>

<script>
import scan from '@/components/ScanBar.vue';
import loading from '@/components/Loading.vue';

export default {
  components: {
    scan,
    loading
  },
  props: {},
  data() {
    return {
      scanShow: false,
      pagePushLoading: false,
      formData: {
        sn_num: ''
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {
    
  },
  watch: {
    value: {
      handler: function(newv, oldv) {
      },
      immediate: true,
      deep: true
    },
  },

  methods: {
    init() {},
    search() {
      if (!this.formData['sn_num']) {
        this.$toast.fail('请输入服务器SN号');
        return;
      }
      this.$router.push('/saleRep/partSearch/' + this.formData['sn_num']);
    },
    scanDetect(val) {
      this.$toast.success('识别成功');
      this.formData.sn_num = val;
    },
    repair() {
      this.$router.push('/saleRep/repairSn');
    },
    
    async turnTo(type) {
      if (!this.formData['sn_num']) {
        this.$toast.fail('请输入服务器SN号');
        return;
      }

      this.pagePushLoading = true;
      // 测试域名http://www.mest_toasin.test/check/index/serverSnPartSearch
      // let url = "http://www.mest_toasin.test/check/index/serverSnPartSearch";
      let url = "https://mes.toasin.cn/check/index/serverSnPartSearch";
      await this.$post(url, { server_sn: this.formData.sn_num }).then((res) => {
        if (res.code === 1) {
          if (res['data']) {
            if (type == 'list') {
              this.$router.push("/saleRep/order/all/" + res['data']['order_code']);
            } else {
              this.$router.push('/saleRep/submit/' + res['data']['order_code']);
            }
          } else {
            this.$toast.fail(`${this.formData.sn_num},该服务器SN号不存在，请检查`);
            this.pagePushLoading = false;
            return;
          }
        } else {
          this.$toast.fail(res.msg);
          this.pagePushLoading = false;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.sale-rep-index {
  width: 100%;
  height: 100%;
  background-color: white;
  position: relative;
  margin: 0px;
  .group-logo {
    width: 59px;
    padding-top: 84px;
    margin: 0px auto;
    img{
      max-width: 59px;
    }
  }

  .group-name {
    width: 100%;
    text-align: center;
    color: rgba(80, 80, 80, 1);
    font-size: 22px;
    line-height: 150%;
    margin: 30px 0px 26px;
  }

  .service-sn-field {
    width: 332px;
    height: 49px;
    box-shadow: inset 0 0 0 2px rgb(223,223,223);
    border-radius: 11px;
    margin: 0px auto;

    /deep/ .van-icon-scan {
      font-size: 28px!important;
      line-height: 32px;
    }
  }


  .search-btn {
    width: 332px;
    height: 49px;
    color: rgba(255, 255, 255, 1);
    background-color: rgba(42, 130, 228, 1);
    border-color: #2a82e4;
    border-radius: 11px;
    font-size: 14px;
    line-height: 49px;
    text-align: center;
    margin: 33px auto 0px;
  }

  /deep/ .list-btn {
    background-color: #07c160 !important;
    border: 1px solid #07c160 !important;
  }

  .form-submit-button {
    box-sizing: border-box;
    padding-left: 5%;
    padding-right: 5%;
    width: 100%;
    display:flex;
    justify-content: center;
    z-index: 1;

    .form-submit-box {
      width: 332px;
      display:flex;
      justify-content: space-between;
      .search-btn {
        margin: 33px 0px
      }
    }

    .search-btn {
      width: 48%;
    }
  }
}


</style>

